import { getItemMaker } from "./tools";

const i = getItemMaker("misc");
export const misc = [
  i("Golden Oyster"),
  i("Obol Fragment"),
  i("Quality Obol Stack", "GemP9"),
  i("Marvelous Obol Stack"),
  i("Bossius Obol Stack"),
  i("Hyper Obol Stack"),
  i("Hyper Obol Stack Square Edition", "GemP35"),

  i("Crude Oil", "OilBarrel1"),
  i("Toxic Sludge", "OilBarrel2"),
  i("Radioactive Waste", "OilBarrel3"),
  i("Eco Friendly Oil"),
  i("Magma Barrel", "OilBarrel6"),
  i("Plasma Barrel", "OilBarrel7"),
  i("Glumlee's Special Tutorial Oil", "OilBarrel4"),

  i("Googley Eyes", "Quest35"),
  i("Dootjat Eye"),
  i("Guild Giftbox", "Quest38"),
  i("Lovey Dovey Letter", "Quest39"),
  i("Choco Box", "Quest40"),
  i("Egg Capsule"),
  i("Gummy Bunny"),
  i("Goldegg Capsule"),
  i("Beach Oyster"),
  i("Phone Box", "Quest70"),
  i("Gem Envelope", "Quest71"),
  i("Spring Baggie"),
  i("Anniversary Box", "Quest85"),
  i("Falloween Treat"),
  i("Golden Gift", "Quest91"),
  i("Mayonnaise Bottle"),
  i("Broken Weapon"),
  i("Dried Paint Blob"),
  i("Engraved Bullet"),
  i("Silver Antique", "Quest37"),
  i("2021 Giftmas Box"),
  i("Newbie Card Pack", "CardPack1"),
  i("Ancient Card Pack", "CardPack2"),
  i("Eternal Card Pack", "CardPack3"),
  i("Dungeon Card Pack", "CardPack4"),
  i("Galaxy Card Pack", "CardPack5"),
  i("Smolderin Card Pack", "CardPack6"),
  i("Dungeon Loot Dice", "GemP16"),
  i("Birthday Candle", "Quest95"),

  i("Pile of Processor Chips"),
  i("Strung Jewels", "Quest66"),
  i("Blue Tome Pages"),
  i("Red Tome Pages"),
];
